var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { staticClass: "pa-0 mb-12" }, [
    _c(
      "div",
      { staticClass: "d-flex my-18px" },
      [
        _c("h2", { staticClass: "noselect" }, [_vm._v("Šablóny")]),
        _c(
          "v-btn",
          {
            staticClass: "btn-primary link ml-auto mr-n3",
            attrs: { ripple: false }
          },
          [_vm._v("Všetky šablóny")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dash-container-body" },
      [
        _c(
          "v-row",
          { staticClass: "mx-n4", attrs: { "no-gutters": "" } },
          _vm._l(_vm.data, function(item, index) {
            return _c(
              "v-col",
              {
                key: index,
                staticClass: "px-4",
                attrs: { xl: "3", lg: "3", md: "3" }
              },
              [
                _c(
                  "v-card",
                  { staticClass: "pa-5 card-item-dark" },
                  [
                    _c("text-group", {
                      attrs: {
                        utext: "Názov šablóny",
                        btext: item.nazov,
                        large: ""
                      }
                    }),
                    _c("text-group", {
                      staticClass: "mt-12px",
                      attrs: {
                        utext: "Popis",
                        btext: item.popis,
                        smallHeader: "",
                        btextBold: false
                      }
                    }),
                    _c("v-divider", { staticClass: "my-8px" }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-secondary",
                        attrs: { icon: "", small: "", tile: "", outlined: "" }
                      },
                      [
                        _c("v-icon", { attrs: { dark: "", size: "18" } }, [
                          _vm._v(" mdi-reply ")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }